import { render, staticRenderFns } from "./CarListItem.vue?vue&type=template&id=2efbfb2f&"
import script from "./CarListItem.vue?vue&type=script&lang=js&"
export * from "./CarListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports